import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_da98dbcd-f751-4482-bd4e-a7e20426ba71/artifacts/tm6wbpvj_CD8D187A-3FEA-430F-A897-685C7F8A2178.png";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--bg-primary)" }} data-testid="privacy-page">
      <div className="px-6 md:px-12 py-8 border-b" style={{ borderColor: "var(--border)" }}>
        <Link to="/"><img src={LOGO_URL} alt="Green Routes" className="h-8 md:h-10 mx-auto logo-blend" /></Link>
      </div>

      <div className="flex-1 max-w-3xl mx-auto px-6 py-12 md:py-16">
        <p className="text-xs tracking-[0.2em] uppercase mb-4 font-semibold" style={{ color: "var(--text-tertiary)" }}>Legal</p>
        <h1 className="text-3xl sm:text-4xl tracking-tight mb-3" style={{ color: "var(--text-primary)" }}>Privacy Policy</h1>
        <p className="text-sm mb-10" style={{ color: "var(--text-tertiary)" }}>Last updated: August 2026</p>

        <div className="space-y-8 text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>1. Information We Collect</h2>
            <p>We collect information you provide directly, including: name, email address, phone number, business details, sourcing requirements, budget range, and compliance needs submitted through our intake forms. We also collect chat messages sent through our website chat widget, and payment information processed securely through Stripe (we do not store credit card numbers).</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>2. How We Use Your Information</h2>
            <p>We use the information collected to: route you to the appropriate service tier, schedule and conduct consultations, facilitate introductions to cultivators and suppliers, process payments, send booking confirmations and follow-up communications, improve our services and website experience, and comply with legal obligations.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>3. Information Sharing</h2>
            <p>We do not sell, rent, or trade your personal information. We may share limited information with: cultivator partners (only upon your approval and after consultation), payment processors (Stripe) to complete transactions, and legal authorities if required by law. All partners are bound by confidentiality agreements.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>4. Data Security</h2>
            <p>We implement industry-standard security measures to protect your information, including encrypted data transmission (HTTPS/TLS), secure authentication with httpOnly session cookies, and access controls limiting data visibility to authorized personnel only. However, no method of electronic storage is 100% secure.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>5. Cookies &amp; Tracking</h2>
            <p>We use essential cookies for authentication and session management. We may use analytics tools to understand website usage patterns. We do not use third-party advertising cookies or sell data to advertisers.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>6. Data Retention</h2>
            <p>We retain your personal information for as long as necessary to fulfill the purposes described in this policy, maintain business records, and comply with legal obligations. You may request deletion of your data at any time by contacting us.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>7. Your Rights</h2>
            <p>You have the right to: access the personal information we hold about you, request correction of inaccurate information, request deletion of your data (subject to legal retention requirements), opt out of marketing communications, and receive a copy of your data in a portable format. To exercise these rights, contact us using the information below.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>8. California Residents (CCPA)</h2>
            <p>If you are a California resident, you have additional rights under the California Consumer Privacy Act (CCPA), including the right to know what personal information is collected, the right to request deletion, and the right to opt-out of the sale of personal information. We do not sell personal information.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date. Your continued use of the Services after changes constitutes acceptance.</p>
          </section>

          <section>
            <h2 className="text-lg mb-3" style={{ color: "var(--text-primary)" }}>10. Contact Us</h2>
            <p>For privacy-related inquiries, contact us at <a href="mailto:Greenroutesconsulting@gmail.com" style={{ color: "var(--primary)", fontWeight: 500 }}>Greenroutesconsulting@gmail.com</a> or <a href="https://buy.stripe.com/test_3cI3cw76afo3dj8ekM2cg00" target="_blank" rel="noopener noreferrer" style={{ color: "var(--primary)", fontWeight: 500 }}>book a consultation</a>.</p>
          </section>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
}
